import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { Button } from "./ui/button";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "./ui/command";
import { buildIndex } from "../lib/searchIndex";

const GROUPS = [
  ["markets", "x.searchMarkets"],
  ["tools", "x.searchTools"],
  ["compare", "x.searchCompare"],
  ["learn", "x.searchLearn"],
];

export function SearchCommand() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const index = buildIndex();

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        aria-label={t("x.search")}
        data-testid="search-trigger"
        className="h-9 gap-2 px-2.5 text-muted-foreground"
      >
        <Search className="h-4 w-4" />
        <span className="hidden text-xs md:inline">{t("x.search")}</span>
      </Button>
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder={t("x.searchPlaceholder")} data-testid="search-input" />
        <CommandList>
          <CommandEmpty>{t("x.searchNone")}</CommandEmpty>
          {GROUPS.map(([g, headingKey]) => (
            <CommandGroup key={g} heading={t(headingKey)}>
              {index[g].map((it, i) => {
                const label = it.label || t(it.labelKey, { defaultValue: it.raw });
                return (
                  <CommandItem key={g + i} value={`${label} ${it.to}`} onSelect={() => go(it.to)} data-testid={`search-item-${g}-${i}`}>
                    {label}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          ))}
        </CommandList>
      </CommandDialog>
    </>
  );
}
